import { Ace2ClaimAction } from "./types";

export const createAce2Claim = (payload) =>
  ({
    type: Ace2ClaimAction.CREATE_CLAIM,
    payload,
  }) as const;

export const insertClaimItems = (payload) =>
  ({
    type: Ace2ClaimAction.INSERT_CLAIM_ITEMS,
    payload,
  }) as const;

export const removeClaimItem = (payload) =>
  ({
    type: Ace2ClaimAction.REMOVE_CLAIM_ITEM,
    payload,
  }) as const;

export const insertClaimItemDamages = (payload) =>
  ({
    type: Ace2ClaimAction.INSERT_CLAIM_ITEM_DAMGES,
    payload,
  }) as const;

export const setWarrItems = (payload) =>
  ({
    type: Ace2ClaimAction.SET_WARRNTY_ITEMS,
    payload,
  }) as const;

export const setClaimInfo = (payload) =>
  ({
    type: Ace2ClaimAction.SET_CLAIM_INFO,
    payload,
  }) as const;

export const submitClaim = () =>
  ({
    type: Ace2ClaimAction.SUBMIT_CLAIM,
  }) as const;

export const fetchClaimInfo = (payload) =>
  ({
    type: Ace2ClaimAction.FETCH_CLAIM_INFO,
    payload,
  }) as const;

export const cleanUpClaimInfo = () =>
  ({
    type: Ace2ClaimAction.CLEAN_UP,
  }) as const;

export const deleteClaimCreateNew = (payload) =>
  ({
    type: Ace2ClaimAction.DELETE_CLAIM_CREATE_NEW,
    payload,
  }) as const;

export const handleClaimItemFileUpload = (payload) =>
  ({
    type: Ace2ClaimAction.CLAIM_ITEM_UPLOAD,
    payload,
  }) as const;

export const removeClaimItemImage = (payload) =>
  ({
    type: Ace2ClaimAction.CLAIM_ITEM_DELETE_IMAGE,
    payload,
  }) as const;

export const updateCustomerInfo = (payload) =>
  ({
    type: Ace2ClaimAction.UPDATE_CUSTOMER_INFO,
    payload,
  }) as const;

export const removeClaimItemDamage = (payload) =>
  ({
    type: Ace2ClaimAction.DELETE_DAMAGE_ITEM,
    payload,
  }) as const;

export const setDraftModal = (payload: {
  isShow: boolean;
  claimId: string | null;
}) =>
  ({
    type: Ace2ClaimAction.SET_DRAFT_MODAL,
    payload,
  }) as const;

export const setInProcessModal = (payload: {
  isShow: boolean;
  claimStatusCode: string | null;
}) =>
  ({
    type: Ace2ClaimAction.SET_IN_PROCESS_MODAL,
    payload,
  }) as const;

export const setSubmitErrorModal = (payload: {
  isShow: boolean;
  message: string | null;
}) =>
  ({
    type: Ace2ClaimAction.SET_SUBMIT_ERROR_MODAL,
    payload,
  }) as const;
